import { useEffect, useState } from "react";
import NavBar from "../../../components/organisms/navbar";
import {
  Container,
  Content,
  InfoContainerStatus,
  InfoContainerText,
  PageTitle,
  PageTitleContainer,
  StatusButton,
  SubscriptionContainer,
  SubscriptionContent,
  SubscriptionDescription,
  SubscriptionItem,
  SubscriptionList,
  SubscriptionTitle,
} from "../../profile/subscriptions/styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Loading from "../../../components/atoms/loading";
import React from "react";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useParams } from "react-router-dom";
import { StringToSlug, StringToSlugPraia } from "../../../utils/SlugConverter";
import { TournamentLink } from "src/pages/tournament/styles";
import { FormContent } from "src/pages/auth/change-password/styles";
import { useForm } from "react-hook-form";
import { FormGroup } from "../../auth/login/styles";
import Input from "../../../components/atoms/input";
import BasicModal from "src/components/organisms/tournamentBracket/modal";
import {
  Box,
  Button,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Zoom,
  TextField,
  MenuItem,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Swal from "sweetalert2";
import { HistoryModal } from "src/components/atoms/historyModal";
import HistoryIcon from '@mui/icons-material/History';
import { ScrollableTable } from "src/components/atoms/reportTable";

import rulesGi from "../../../data/rules-lijjam-combat-ix-de-jiu-jitsu-2026-gi.json";
import rulesNoGi from "../../../data/rules-lijjam-combat-ix-de-jiu-jitsu-2026-nogi.json";

const slugGi = "lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi";
const slugNoGi = "lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi";

// ================================
// DEFAULTS (VALORES PADRÃO)
// ================================
const DEFAULT_EVENTO_INICIO = "08:30";
const DEFAULT_AREAS_DE_LUTA = 5;
const DEFAULT_PERIODO_MINUTOS = 60;
const DEFAULT_REGRA_CHAVE_3 = "chaveDe3MelhorDe3" as
  | "chaveDe3Simples"
  | "chaveDe3MelhorDe3";

const AllCheckCategoriesLijjamCombatIxCombatDeJiuJitsu2026 = () => {
  //let senha = "teste"
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  let password = {
    torneio: "Lijjamcombat@2026",
    credenciais: {
      usuario: "Lijjamcombat@2026",
      senha: "Lijjamcombat@2026",
    },
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getToken, account } = useAuthenticate();


  const [dataTratada, setDataTratada] = useState<
  { category: string; figthers: any; order: number }[]
>([]);




  const [showData, setShowData] = useState(false);
  const url = window.location.pathname;
  const { slug } = useParams();
  const [tournament, setTournament] = useState<any>({});
  const [subscription, setSubscription] = useState<any>([]);
  const [senha, setSenha] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();
  const [manager, setManager] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [suggestedPairs, setSuggestedPairs] = useState<{
    a: any; b: any; beltDiff: number; reasons: string[]; pairEntry: any; soloA: any; soloB: any;
  }[]>([]);
  const [countCategories, setCountCategories] = useState<any>([]);
  const [filterShirt, setFilterShirt] = useState<"all" | "with" | "without">("all");

  // ================================
  // SIMULADOR (ESTADOS COM PADRÃO)
  // ================================
  const [eventoInicio, setEventoInicio] = useState(DEFAULT_EVENTO_INICIO);
  const [areasDeLuta, setAreasDeLuta] = useState(DEFAULT_AREAS_DE_LUTA);
  const [regraChave3, setRegraChave3] = useState<
    "chaveDe3Simples" | "chaveDe3MelhorDe3"
  >(DEFAULT_REGRA_CHAVE_3);
  const [periodoMinutos, setPeriodoMinutos] = useState(DEFAULT_PERIODO_MINUTOS);

  const [genderFilter, setGenderFilter] = useState<"all" | "masculino" | "feminino">("all");

  const filterByGender = (data: any[]) => {
    if (genderFilter === "all") return data;
    return data.filter(
      (value) => value.genre?.toLowerCase() === genderFilter
    );
  };

  const handleCheckPassword = (data: any) => {
    if (data.password === password.credenciais.senha) {
      setIsAuthorized(true);
    } else {
      alert("Senha incorreta");
    }
  };

  const getFirstCategoryPart = (title: string) => {
  const t = (title ?? "").toString().trim();

  const beforeSlash = t.split("/")[0].trim();
  const beforeSemicolon = beforeSlash.split(";")[0].trim();
  const beforeDashSpaces = beforeSemicolon.split(" - ")[0].trim();

  return beforeDashSpaces;
};

  const handleEditFighter = (fighterId: number) => {

    if (manager) {
      Swal.fire({
        title: "Como deseja editar sua inscrição?",
        text: "Você pode editar seguindo as regras do evento ou livremente.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: '#373737',
        confirmButtonText: "Editar com regras",
        denyButtonText: "Editar sem regras",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url, mode: 'regras' } });
        else if (result.isDenied) navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url, mode: 'livre' } });
      });
    } else {
      navigate(`/enrollment-update/${fighterId}/${slug}`, { state: { from: url } });
    }

  }

  const showHistorySubsModal = async (subscriptionId: number) => {

    await api.get(`/history/Subscription/${subscriptionId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    ).then(res => {
      setHistoryData(res.data);
      setIsModalOpen(true);
    })

  }

  const normalize = (v: unknown) =>
    (v ?? "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s*-\s*/g, "-")
      .replace(/\s+/g, " ");

  console.log(normalize('MÉDIO1'))

  const normalizeCategory = (cat: unknown) => {
    const n = normalize(cat);
    if (!n) return n;
    const parts = n.split("-").map(p => p.trim());
    return parts[parts.length - 1] || n;
  };

  const getOrder = <T extends string>(
    map: Record<string, number>,
    key: unknown,
    fallback = 999
  ) => map[normalize(key as string)] ?? fallback;

  const baseCategory = (raw: unknown) => {
    const n = normalize(raw);
    if (!n) return n;

    if (/\s[-–—]\s/.test(n)) {
      const parts = n.split(/\s[-–—]\s/);
      return parts[parts.length - 1] || n;
    }

    return n;
  };

  const beltOrderSafe = (beltRaw: unknown, beltMap: Record<string, number>) => {
    const b = normalize(beltRaw);
    if (!b) return 999;

    if (b in beltMap) return beltMap[b];

    if (b.includes(" e ")) {
      const parts = b.split(" e ").map(x => x.trim());
      const nums = parts.map(p => beltMap[p] ?? 999);
      return Math.min(...nums);
    }

    return beltMap[b] ?? 999;
  };

  const weightOrderSafe = (wRaw: unknown, wMap: Record<string, number>) =>
    wMap[normalize(wRaw)];

  const genderOrderMap: Record<string, number> = {
    "feminino": 1,
    "masculino": 2,
  };

  const genderOrderSafe = (gRaw: unknown) =>
    genderOrderMap[normalize(gRaw)] ?? 99;

  const parseTitle = (title: string) => {
    const [cat, gen, belt, weight] = title.split("/");
    return {
      catRaw: cat ?? "",
      genRaw: gen ?? "",
      beltRaw: belt ?? "",
      weightRaw: weight ?? "",
      catBase: baseCategory(cat),
    };
  };

  const isParaOrPCD = (catRaw: unknown) => {
    const c = normalize(catRaw);
    return c.startsWith("pcd") || c.startsWith("parajiu");
  };

  const categoryOrder: { [key: string]: number } = {
    "luta casada; pre-mirim": 1,
    "luta casada; mirim a": 2,
    "luta casada; mirim b": 3,
    "luta casada; infantil a": 4,
    "luta casada; infantil b": 5,
    "luta casada; infanto juvenil": 6,
    "luta casada; juvenil": 7,
    "luta casada; adulto": 8,
    "luta casada; master 1 e 2": 9,
    "luta casada; master 3, 4 e 5": 10,
  };

  // Neste evento: cinza, amarela, laranja e verde são todos "graduado" e podem lutar entre si
  const beltOrder: { [key: string]: number } = {
    branca: 1,
    graduado: 2,
    cinza: 2,
    amarela: 2,
    laranja: 2,
    verde: 2,
    'laranja e verde': 2,
    azul: 3,
    roxa: 4,
    marrom: 5,
    preta: 6,
  };

  const weightOrder: { [key: string]: number } = {
    "casamento manual": 1,
    galo: 2,
    pluma: 3,
    "pena": 4,
    "leve": 5,
    medio: 6,
    "meio pesado": 7,
    pesado: 8,
    "super pesado": 9,
    pesadíssimo: 10,
    absoluto: 11,
  };

  interface User {
    id: number;
    name: string;
    phone: string;
    email: string;
    gym: string;
    genre: string;
  }

  interface Fighter {
    id: number;
    weight: string;
    genre: string;
    age: string;
    belt: string;
    category: string;
    valueSubscription: string;
    status: boolean;
    created_at: string;
    updated_at: string;
    userId: number;
    fightersId: number | null;
    tournamentId: number;
    fighters: any;
    user: User;
  }

  const matchAthletes = (rawItems: any[]) => {
    // Retorna idade em anos decimais a partir da data de nascimento
    const calcAge = (item: any): number => {
      const bd = item.fighters?.birth_date || item.user?.birth_date;
      if (bd) {
        const [d, m, y] = bd.split('/').map(Number);
        const today = new Date();
        const birth = new Date(y, m - 1, d);
        return (today.getTime() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000);
      }
      return parseFloat(item.age) || 0;
    };

    const parseWeightKg = (item: any): number => {
      const raw = (item.weight || '').split(';')[0].replace(',', '.').replace('kg', '').trim();
      return parseFloat(raw) || 0;
    };

    const getWeightCat = (item: any): string =>
      normalize((item.weight || '').split(';')[1] || '');

    const getGenre = (item: any): string => normalize(item.genre || '');

    const getBeltNum = (item: any): number => beltOrder[normalize(item.belt)] ?? 999;

    // Usa item.age (idade oficial do torneio) para classificar adulto/criança
    const isAdult = (item: any): boolean => parseInt(item.age) >= 18;

    // Regras progressivas: crianças (<18) usam kidsAgeDiff, adultos (>=18) usam adultsAgeDiff
    // weightKgDiff: null = mesma categoria textual exata; número = tolerância em kg
    type Rule = { kidsAgeDiff: number; adultsAgeDiff: number; beltDiff: number; weightKgDiff: number | null };

    const rules: Rule[] = [
      // Passa 1: mesmo tudo (sexo, idade exata, faixa, peso)
      { kidsAgeDiff: 0,   adultsAgeDiff: 0,   beltDiff: 0, weightKgDiff: null },
      // Passa 2: crianças ±6 meses / adultos ±2 anos, mesma faixa, mesmo peso
      { kidsAgeDiff: 0.5, adultsAgeDiff: 2,   beltDiff: 0, weightKgDiff: null },
      // Passa 3: crianças ±6 meses / adultos ±2 anos, mesma faixa, ±2kg
      { kidsAgeDiff: 0.5, adultsAgeDiff: 2,   beltDiff: 0, weightKgDiff: 2 },
      // Passa 4: crianças ±1 ano / adultos ±2 anos, mesma faixa, mesmo peso
      { kidsAgeDiff: 1,   adultsAgeDiff: 2,   beltDiff: 0, weightKgDiff: null },
      // Passa 5: crianças ±1 ano / adultos ±2 anos, mesma faixa, ±2kg
      { kidsAgeDiff: 1,   adultsAgeDiff: 2,   beltDiff: 0, weightKgDiff: 2 },
      // Passa 6: crianças ±1 ano / adultos ±2 anos, mesma faixa, ±5kg
      { kidsAgeDiff: 1,   adultsAgeDiff: 2,   beltDiff: 0, weightKgDiff: 5 },
      // Passa 7: crianças ±2 anos / adultos ±5 anos, mesma faixa, ±5kg
      { kidsAgeDiff: 2,   adultsAgeDiff: 5,   beltDiff: 0, weightKgDiff: 5 },
      // Passa 8: crianças ±2 anos / adultos ±5 anos, mesma faixa, ±10kg
      { kidsAgeDiff: 2,   adultsAgeDiff: 5,   beltDiff: 0, weightKgDiff: 10 },
      // Passa 9: faixa adjacente, crianças ±6 meses / adultos ±2 anos, mesmo peso
      { kidsAgeDiff: 0.5, adultsAgeDiff: 2,   beltDiff: 1, weightKgDiff: null },
      // Passa 10: faixa adjacente, crianças ±1 ano / adultos ±2 anos, ±2kg
      { kidsAgeDiff: 1,   adultsAgeDiff: 2,   beltDiff: 1, weightKgDiff: 2 },
      // Passa 11: faixa adjacente, crianças ±1 ano / adultos ±2 anos, ±5kg
      { kidsAgeDiff: 1,   adultsAgeDiff: 2,   beltDiff: 1, weightKgDiff: 5 },
      // Passa 12: faixa adjacente, crianças ±2 anos / adultos ±5 anos, ±10kg
      { kidsAgeDiff: 2,   adultsAgeDiff: 5,   beltDiff: 1, weightKgDiff: 10 },
      // Passa 13: faixa adjacente, crianças ±3 anos / adultos ±5 anos, ±15kg
      { kidsAgeDiff: 3,   adultsAgeDiff: 5,   beltDiff: 1, weightKgDiff: 15 },
      // Passa 14: último recurso - máximo 1 faixa, máximo 20kg — acima disso vai para autorização manual
      { kidsAgeDiff: 999, adultsAgeDiff: 999, beltDiff: 1, weightKgDiff: 20 },
    ];

    // Limite máximo de peso por faixa etária (usa idade oficial do torneio):
    // ≤13 anos: 3kg | 14-17 anos: 5kg | ≥18 anos: 10kg
    const maxWeightDiff = (item: any): number => {
      const age = parseInt(item.age);
      if (age >= 18) return 10;
      if (age > 13) return 5;
      return 3;
    };

    const canMatch = (a: any, b: any, rule: Rule): boolean => {
      if (getGenre(a) !== getGenre(b)) return false;
      const aAdult = isAdult(a);
      const bAdult = isAdult(b);
      if (aAdult !== bAdult) {
        // Exceção: 17 e 18 anos podem lutar juntos (fronteira juvenil/adulto)
        const ageA = parseInt(a.age);
        const ageB = parseInt(b.age);
        if (!(ageA >= 17 && ageA < 19 && ageB >= 17 && ageB < 19)) return false;
      }
      // Crianças (<18): máximo 2 anos de diferença
      // Adultos 18-29: podem lutar entre si livremente
      // Adultos 30+: máximo 5 anos de diferença
      const effectiveAdultAgeTol = (() => {
        const ageA = parseInt(a.age);
        const ageB = parseInt(b.age);
        if (ageA < 30 && ageB < 30) return rule.adultsAgeDiff; // 18-29: sem restrição extra
        return Math.min(rule.adultsAgeDiff, 5); // qualquer 30+: máximo 5 anos
      })();
      const ageTol = aAdult ? effectiveAdultAgeTol : Math.min(rule.kidsAgeDiff, 2);
      if (Math.abs(calcAge(a) - calcAge(b)) > ageTol) return false;
      if (Math.abs(getBeltNum(a) - getBeltNum(b)) > rule.beltDiff) return false;
      // Limite de peso por idade — usa o mais restritivo dos dois atletas
      const weightTol = rule.weightKgDiff === null
        ? null
        : Math.min(rule.weightKgDiff, maxWeightDiff(a), maxWeightDiff(b));
      const kgDiff = Math.abs(parseWeightKg(a) - parseWeightKg(b));
      if (weightTol === null) {
        if (getWeightCat(a) !== getWeightCat(b)) return false;
        // Mesmo na mesma categoria textual, aplica limite de kg por faixa etária
        if (kgDiff > Math.min(maxWeightDiff(a), maxWeightDiff(b))) return false;
      } else {
        if (kgDiff > weightTol) return false;
      }
      return true;
    };

    const matchScore = (a: any, b: any): number =>
      Math.abs(calcAge(a) - calcAge(b)) * 100 +
      Math.abs(getBeltNum(a) - getBeltNum(b)) * 10 +
      Math.abs(parseWeightKg(a) - parseWeightKg(b));

    const used = new Set<number>();
    const pairs: {
      title: string;
      data: any[];
      ageVal: number;
      genderVal: number;
      beltVal: number;
      weightVal: number;
    }[] = [];

    for (const rule of rules) {
      const unmatched = rawItems.filter(a => !used.has(a.id));
      if (unmatched.length < 2) break;

      const ruleUsed = new Set<number>();

      for (let i = 0; i < unmatched.length; i++) {
        const a = unmatched[i];
        if (ruleUsed.has(a.id)) continue;

        let best: any = null;
        let bestScore = Infinity;

        for (let j = i + 1; j < unmatched.length; j++) {
          const b = unmatched[j];
          if (ruleUsed.has(b.id)) continue;
          if (canMatch(a, b, rule)) {
            const s = matchScore(a, b);
            if (s < bestScore) { bestScore = s; best = b; }
          }
        }

        if (best) {
          ruleUsed.add(a.id);
          ruleUsed.add(best.id);
          used.add(a.id);
          used.add(best.id);
          pairs.push({
            title: `${a.category}/${getGenre(a)}/${normalize(a.belt)}/${getWeightCat(a)}`,
            data: [a, best],
            ageVal: calcAge(a),
            genderVal: genderOrderMap[getGenre(a)] ?? 99,
            beltVal: getBeltNum(a),
            weightVal: parseWeightKg(a),
          });
        }
      }
    }

    const makeSolo = (a: any) => ({
      title: `${a.category}/${getGenre(a)}/${normalize(a.belt)}/${getWeightCat(a)}`,
      data: [a],
      ageVal: calcAge(a),
      genderVal: genderOrderMap[getGenre(a)] ?? 99,
      beltVal: getBeltNum(a),
      weightVal: parseWeightKg(a),
    });

    const buildReasons = (a: any, b: any): string[] => {
      const reasons: string[] = [];

      const beltDiffVal = Math.abs(getBeltNum(a) - getBeltNum(b));
      if (beltDiffVal > 1) {
        reasons.push(`Faixa: diferença de ${beltDiffVal} nível(is) — máximo permitido: 1`);
      }

      const weightDiffVal = Math.abs(parseWeightKg(a) - parseWeightKg(b));
      const effectiveWLimit = Math.min(maxWeightDiff(a), maxWeightDiff(b));
      if (weightDiffVal > effectiveWLimit) {
        reasons.push(`Peso: diferença de ${weightDiffVal.toFixed(1)}kg — limite para esta faixa etária: ${effectiveWLimit}kg`);
      }

      const aAdultVal = isAdult(a);
      const bAdultVal = isAdult(b);
      if (aAdultVal !== bAdultVal) {
        const ageA = parseInt(a.age);
        const ageB = parseInt(b.age);
        const isTransition = ageA >= 17 && ageA < 19 && ageB >= 17 && ageB < 19;
        if (!isTransition) {
          reasons.push(`Categoria: um atleta é adulto (≥18) e o outro é juvenil/infantil`);
        }
      }

      const ageAVal = parseInt(a.age);
      const ageBVal = parseInt(b.age);
      const ageDiffVal = Math.abs(ageAVal - ageBVal);
      const isKids = ageAVal < 18 && ageBVal < 18;
      const bothYoungAdults = ageAVal >= 18 && ageAVal < 30 && ageBVal >= 18 && ageBVal < 30;
      const maxAgeDiffAllowed = isKids ? 2 : bothYoungAdults ? 999 : 5;
      if (ageDiffVal > maxAgeDiffAllowed) {
        const motivo = isKids
          ? `Idade: diferença de ${ageDiffVal.toFixed(0)} ano(s) — limite para crianças: 2 anos`
          : `Idade: diferença de ${ageDiffVal.toFixed(0)} ano(s) — limite para atletas 30+: 5 anos`;
        reasons.push(motivo);
      }

      return reasons.length > 0 ? reasons : ['Combinação fora dos critérios automáticos'];
    };

    // Atletas sem par — verificar se há sugestão que requer autorização manual
    const remaining = rawItems.filter(a => !used.has(a.id));
    const suggestUsed = new Set<number>();
    const suggestions: { a: any; b: any; beltDiff: number; reasons: string[]; pairEntry: any; soloA: any; soloB: any }[] = [];

    for (let i = 0; i < remaining.length; i++) {
      const a = remaining[i];
      if (suggestUsed.has(a.id)) continue;

      let best: any = null;
      let bestScore = Infinity;

      for (let j = i + 1; j < remaining.length; j++) {
        const b = remaining[j];
        if (suggestUsed.has(b.id)) continue;
        if (getGenre(a) !== getGenre(b)) continue;
        const s = matchScore(a, b);
        if (s < bestScore) { bestScore = s; best = b; }
      }

      if (best) {
        suggestUsed.add(a.id);
        suggestUsed.add(best.id);
        suggestions.push({
          a,
          b: best,
          beltDiff: Math.abs(getBeltNum(a) - getBeltNum(best)),
          reasons: buildReasons(a, best),
          pairEntry: {
            title: `${a.category}/${getGenre(a)}/${normalize(a.belt)}/${getWeightCat(a)}`,
            data: [a, best],
            ageVal: calcAge(a),
            genderVal: genderOrderMap[getGenre(a)] ?? 99,
            beltVal: getBeltNum(a),
            weightVal: parseWeightKg(a),
          },
          soloA: makeSolo(a),
          soloB: makeSolo(best),
        });
      } else {
        // Sem nenhuma possibilidade — vai direto como sem luta
        pairs.push(makeSolo(a));
      }
    }

    // Atletas que ficaram fora das sugestões também são sem luta
    remaining.filter(a => !suggestUsed.has(a.id) && !pairs.some(p => p.data[0]?.id === a.id))
      .forEach(a => pairs.push(makeSolo(a)));

    // Ordena: feminino primeiro, mais novo primeiro, faixa mais leve, peso mais leve
    pairs.sort((a, b) => {
      if (a.genderVal !== b.genderVal) return a.genderVal - b.genderVal;
      if (a.ageVal !== b.ageVal) return a.ageVal - b.ageVal;
      if (a.beltVal !== b.beltVal) return a.beltVal - b.beltVal;
      return a.weightVal - b.weightVal;
    });

    return { pairs, suggestions };
  };

  function converterSubscriptions(array: any) {
    const { pairs, suggestions } = matchAthletes(array);
    setSubscription(pairs);
    setSuggestedPairs(suggestions);

    const dataTratadaArr: { category: string; figthers: any; order: number }[] = [];
    pairs.forEach((item, index) => {
      dataTratadaArr.push({
        category: `${item.title} -${index + 1}`,
        order: index + 1,
        figthers: item.data.map((sub: any) => ({
          name: sub.fighters ? sub.fighters.name : sub.user.name,
          gym: sub.fighters ? sub.fighters.gym : sub.user.gym,
          belt: sub.belt,
          weight: sub.weight,
        })),
      });
    });
    setDataTratada(dataTratadaArr);
  }

  const exportToCSV = () => {
    if (suggestedPairs.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Lutas sugeridas pendentes',
        text: `Ainda há ${suggestedPairs.length} luta(s) sugerida(s) aguardando sua análise. Analise todas antes de exportar.`,
        confirmButtonColor: '#373737',
        confirmButtonText: 'OK',
      });
      return;
    }
    const header = 'Número de Luta;Atleta 1;Academia 1;Idade 1;Peso 1;Faixa 1;Atleta 2;Academia 2;Idade 2;Peso 2;Faixa 2';

    const rows = subscription.map((item: any, index: number) => {
      const num = index + 1;
      const a1 = item.data[0];
      const a2 = item.data[1] || null;

      const name1 = a1.fighters ? a1.fighters.name : a1.user.name;
      const gym1  = a1.fighters ? a1.fighters.gym  : a1.user.gym;
      const age1  = a1.age;
      const peso1 = a1.weight?.split(';')[0]?.trim() || '-';
      const belt1 = a1.belt;

      const name2  = a2 ? (a2.fighters ? a2.fighters.name : a2.user.name) : '-';
      const gym2   = a2 ? (a2.fighters ? a2.fighters.gym  : a2.user.gym)  : '-';
      const age2   = a2 ? a2.age : '-';
      const peso2  = a2 ? (a2.weight?.split(';')[0]?.trim() || '-') : '-';
      const belt2  = a2 ? a2.belt : '-';

      return `${num};${name1};${gym1};${age1};${peso1};${belt1};${name2};${gym2};${age2};${peso2};${belt2}`;
    });

    const csv = '\uFEFF' + [header, ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `lutas-${tournament.name || 'torneio'}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleApproveSuggestion = (idx: number) => {
    const s = suggestedPairs[idx];
    setSubscription((prev: any[]) => {
      const updated = [...prev, s.pairEntry];
      updated.sort((a, b) => {
        if (a.genderVal !== b.genderVal) return a.genderVal - b.genderVal;
        if (a.ageVal !== b.ageVal) return a.ageVal - b.ageVal;
        if (a.beltVal !== b.beltVal) return a.beltVal - b.beltVal;
        return a.weightVal - b.weightVal;
      });
      return updated;
    });
    setSuggestedPairs(prev => prev.filter((_, i) => i !== idx));
  };

  const handleRejectSuggestion = (idx: number) => {
    const s = suggestedPairs[idx];
    setSubscription((prev: any[]) => {
      const updated = [...prev, s.soloA, s.soloB];
      updated.sort((a, b) => {
        if (a.genderVal !== b.genderVal) return a.genderVal - b.genderVal;
        if (a.ageVal !== b.ageVal) return a.ageVal - b.ageVal;
        if (a.beltVal !== b.beltVal) return a.beltVal - b.beltVal;
        return a.weightVal - b.weightVal;
      });
      return updated;
    });
    setSuggestedPairs(prev => prev.filter((_, i) => i !== idx));
  };

  useEffect(() => {
    if (account?.roles?.includes('manager') || tournament.authorId === account.id) {
      setManager(true);
    } else {
      setManager(false);
    }
  }, [account]);

  useEffect(() => {
    setLoading(true);

    api
      .get("/tournaments/" + slug)
      .then(({ data }) => {
        setTournament(data);
      })
      .catch(() => {
        toast.error("Não foi carregar os dados do torneio.");
      });

    api
      .get("/tournaments/enrollments/list-all/public/" + slug, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);

        const sortedArray = data
          .filter((item: Fighter) => item.status === true)
          .slice()
          .sort((a: Fighter, b: Fighter) => {
            const aGenre = normalize(a.genre);
            const bGenre = normalize(b.genre);

            if (aGenre !== bGenre) {
              if (aGenre === "feminino") return -1;
              if (bGenre === "feminino") return 1;
            }

            const aCat = normalizeCategory(a.category);
            const bCat = normalizeCategory(b.category);
            const catDiff = getOrder(categoryOrder, aCat) - getOrder(categoryOrder, bCat);
            if (catDiff !== 0) return catDiff;

            const beltDiff = beltOrderSafe(a.belt, beltOrder) - beltOrderSafe(b.belt, beltOrder);
            if (beltDiff !== 0) return beltDiff;

            const weightDiff = getOrder(weightOrder, a.weight) - getOrder(weightOrder, b.weight);
            if (weightDiff !== 0) return weightDiff;

            const aName = normalize(a.user?.name);
            const bName = normalize(b.user?.name);
            return aName.localeCompare(bName);
          });

        setData(sortedArray);

        if (data && subscription.length === 0)
          converterSubscriptions(sortedArray);

        setShowData(true);
      })
      .catch((err) => {
        console.log(err)
        setLoading(false);
        toast.error("Não foi carregar os dados das inscrições.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) return <Loading text="Aguarde, estamos processando os dados." />;

  let quantidadeInscrcaoPagas = data.length;
  let quatidadeDeChaves = subscription.filter(
    (item: any) => item.data.length > 0
  ).length;
  let quatidadeDeChavesSemLuta = subscription.filter(
    (item: any) => item.data.length === 1
  ).length;

  let medalhasBronze = subscription.filter(
    (item: any) => item.data.length > 2
  ).length;
  let medalhasPrata =
    medalhasBronze +
    subscription.filter((item: any) => item.data.length === 2).length;
  let medalhasOuro =
    medalhasPrata +
    subscription.filter((item: any) => item.data.length === 1).length;

  const columns = [
    { label: "Categoria", key: "title" },
    { label: "Atletas", key: "total" },
  ];

  const getPesoMaximo = (subs: any) => {
    let rulesPesoMaximo;

    if (slug === slugGi) {
      rulesPesoMaximo = rulesGi;
    }

    if (slug === slugNoGi) {
      rulesPesoMaximo = rulesNoGi;
    }

    if (!rulesPesoMaximo) return null;

    return (
      rulesPesoMaximo.find(
        (item: any) =>
          item.genero?.toLowerCase() === subs.genre?.toLowerCase() &&
          item.categoria?.toLowerCase() === subs.category?.toLowerCase() &&
          item.peso?.descricao?.toLowerCase() === subs.weight?.toLowerCase() &&
          item.faixa?.some(
            (f: any) => f.nome?.toLowerCase() === subs.belt?.toLowerCase()
          )
      )?.peso?.max || null
    );
  };

  const getTempoDeLuta = (subs: any) => {
    const regras = slug === slugGi ? rulesGi : rulesNoGi;
    if (!regras) return null;

    const regraCategoria = regras.find(
      (item: any) =>
        item.genero?.toLowerCase() === subs.genre?.toLowerCase() &&
        item.categoria?.toLowerCase() === subs.category?.toLowerCase() &&
        item.faixa?.some(
          (f: any) => f.nome?.toLowerCase() === subs.belt?.toLowerCase()
        )
    );

    if (!regraCategoria) return null;

    const faixa = regraCategoria.faixa.find(
      (f: any) => f.nome?.toLowerCase() === subs.belt?.toLowerCase()
    );

    return faixa?.tempodeLuta || null;
  };

  return (
    <>
      <NavBar />
      <Container>
        <Content id="todaslutas">
          <PageTitleContainer>
            <Typography
              sx={{
                fontSize: "2.0rem",
                fontFamily: "inter, sans-serif",
                fontWeight: 400,
              }}
            >
              CHECAGEM {tournament.name}
            </Typography>

            <Typography
              sx={{
                color: "red",
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
              }}
            >
              Somente inscrições pagas aparecem na checagem
            </Typography>

            {/* Filtro de gênero */}
            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              <Button
                variant={genderFilter === "all" ? "contained" : "outlined"}
                onClick={() => setGenderFilter("all")}
              >
                Todas
              </Button>
              <Button
                variant={
                  genderFilter === "masculino" ? "contained" : "outlined"
                }
                onClick={() => setGenderFilter("masculino")}
              >
                Masculino
              </Button>
              <Button
                variant={
                  genderFilter === "feminino" ? "contained" : "outlined"
                }
                onClick={() => setGenderFilter("feminino")}
              >
                Feminino
              </Button>
            </Box>

            <Box
              sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("semlutas");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Chaves sem lutas
              </Button>

              {manager && suggestedPairs.length > 0 && (
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#b85c00", fontFamily: "inter, sans serif" }}
                  onClick={() => {
                    const section = document.getElementById("sugestoesLutas");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Lutas sugeridas ({suggestedPairs.length})
                </Button>
              )}

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("relatorioTorneio");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Relatório do Torneio
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: suggestedPairs.length > 0 ? "#888" : "#1b5e20",
                  fontFamily: "inter, sans serif",
                }}
                onClick={exportToCSV}
                title={suggestedPairs.length > 0 ? `${suggestedPairs.length} luta(s) sugerida(s) pendente(s)` : ""}
              >
                Exportar CSV {suggestedPairs.length > 0 ? `(${suggestedPairs.length} pendente(s))` : ""}
              </Button>

              {account.id == 34 && (
                <BasicModal
                  chaves={dataTratada}
                  tournamentId={tournament.id}
                  tournamentName={tournament.name}
                  tournamentDate={tournament.date}
                  tournamentLocation={tournament.location}
                  tournamentRules={tournament.rules}
                />
              )}
            </Box>

            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 3,
              }}
            >
              TODAS AS LUTAS
            </Typography>
          </PageTitleContainer>

          <SubscriptionContainer>
            {subscription.map((item: any, catIndex: number) => {
              const filteredData = filterByGender(item.data);

              filteredData.sort((a: any, b: any) => {
                const nomeA = (
                  a.fighters ? a.fighters.name : a.user.name
                ).toLowerCase();
                const nomeB = (
                  b.fighters ? b.fighters.name : b.user.name
                ).toLowerCase();
                return nomeA.localeCompare(nomeB);
              });

              if (showData && filteredData.length > 0) {
                return (
                  <React.Fragment key={item.title}>
                    <br></br>
                    <PageTitle>{`Luta ${catIndex + 1}`}</PageTitle>

                    {filteredData.map((value: any, index: number) => (
                      <SubscriptionList key={value.id}>
                        <SubscriptionItem
                          style={{
                            backgroundColor:
                              value.genre?.toLowerCase() === "feminino"
                                ? "#fee0f1"
                                : "#DBECF4",
                          }}
                        >
                          <SubscriptionContent>
                            <SubscriptionDescription>
                              <InfoContainerText>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div style={{ flexGrow: 1 }}>
                                    <span>
                                      <b>{index + 1}. (Nº {value.id}) </b>
                                      {(value.fighters
                                        ? value.fighters.name
                                        : value.user.name
                                      ).toLocaleUpperCase()}
                                      {" - " +
                                        value.belt?.toUpperCase() +
                                        " - " +
                                        value.weight?.split(";")[0] +
                                        " - " +
                                        value.age +
                                        " anos"}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexShrink: 0,
                                      textAlign: "right",
                                      alignContent: 'center',
                                      gap: 5
                                    }}
                                  >
                                    <span>
                                      {(value.fighters
                                        ? value.fighters.gym
                                        : value.user.gym
                                      ).toLocaleUpperCase()}{" "}
                                    </span>

                                    {(value.userId === account.id ||
                                      manager) && (
                                        <>
                                          <HistoryIcon
                                            color="action"
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => showHistorySubsModal(value.id)} />
                                            {' '}
                                          <EditIcon
                                            color="action"
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => handleEditFighter(value.id)} />

                                        </>
                                      )}
                                  </div>
                                </div>

                              </InfoContainerText>
                            </SubscriptionDescription>
                          </SubscriptionContent>
                        </SubscriptionItem>
                      </SubscriptionList>
                    ))}

                    {filteredData.length === 1 && (
                      <SubscriptionList key="placeholder">
                        <SubscriptionItem style={{ backgroundColor: "#f5f5f5", border: "2px dashed #aaa" }}>
                          <SubscriptionContent>
                            <SubscriptionDescription>
                              <InfoContainerText>
                                <span style={{ color: "#888", fontStyle: "italic" }}>
                                  <b>2. ATLETA 2 — CASAR NA HORA DO EVENTO</b>
                                </span>
                              </InfoContainerText>
                            </SubscriptionDescription>
                          </SubscriptionContent>
                        </SubscriptionItem>
                      </SubscriptionList>
                    )}

                    <br></br> <br></br>
                  </React.Fragment>
                );
              } else {
                return null;
              }
            })}
          </SubscriptionContainer>
        </Content>

        {manager && suggestedPairs.length > 0 && (
          <Content id="sugestoesLutas">
            <PageTitleContainer>
              <Typography sx={{ fontSize: "1.8rem", fontFamily: "inter, sans-serif", fontWeight: "bold", mt: 2, color: "#b85c00" }}>
                {suggestedPairs.length} LUTAS SUGERIDAS — AGUARDANDO SUA AUTORIZAÇÃO
              </Typography>
              <Typography sx={{ fontSize: "1.1rem", fontFamily: "inter, sans-serif", color: "#555", mb: 2 }}>
                Estas lutas possuem diferença de mais de 1 faixa. Analise e autorize ou rejeite cada uma.
              </Typography>
            </PageTitleContainer>
            <SubscriptionContainer>
              {suggestedPairs.map((s, idx) => {
                const nameA = s.a.fighters ? s.a.fighters.name : s.a.user.name;
                const gymA  = s.a.fighters ? s.a.fighters.gym  : s.a.user.gym;
                const nameB = s.b.fighters ? s.b.fighters.name : s.b.user.name;
                const gymB  = s.b.fighters ? s.b.fighters.gym  : s.b.user.gym;
                return (
                  <SubscriptionList key={`sug-${idx}`}>
                    <SubscriptionItem style={{ backgroundColor: "#fff3e0", border: "2px solid #b85c00" }}>
                      <SubscriptionContent>
                        <SubscriptionDescription>
                          <InfoContainerText>
                            <Typography sx={{ fontWeight: "bold", mb: 0.5, color: "#b85c00" }}>
                              Por que não foi casada automaticamente:
                            </Typography>
                            {s.reasons.map((r: string, ri: number) => (
                              <Typography key={ri} sx={{ fontSize: "0.95rem", color: "#b85c00", mb: 0.5 }}>
                                • {r}
                              </Typography>
                            ))}
                            <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", mb: 1 }}>
                              <Box>
                                <span><b>Atleta A:</b> {nameA.toUpperCase()}</span><br />
                                <span><b>Faixa:</b> {s.a.belt} | <b>Peso:</b> {s.a.weight?.split(";")[0]} | <b>Idade:</b> {s.a.age} anos</span><br />
                                <span><b>Academia:</b> {gymA}</span>
                              </Box>
                              <Box>
                                <span><b>Atleta B:</b> {nameB.toUpperCase()}</span><br />
                                <span><b>Faixa:</b> {s.b.belt} | <b>Peso:</b> {s.b.weight?.split(";")[0]} | <b>Idade:</b> {s.b.age} anos</span><br />
                                <span><b>Academia:</b> {gymB}</span>
                              </Box>
                            </Box>
                            <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#2e7d32" }}
                                onClick={() => handleApproveSuggestion(idx)}
                              >
                                Autorizar luta
                              </Button>
                              <Button
                                variant="outlined"
                                color="error"
                                onClick={() => handleRejectSuggestion(idx)}
                              >
                                Rejeitar
                              </Button>
                            </Box>
                          </InfoContainerText>
                        </SubscriptionDescription>
                      </SubscriptionContent>
                    </SubscriptionItem>
                  </SubscriptionList>
                );
              })}
            </SubscriptionContainer>
          </Content>
        )}

        <Content id="semlutas">
          <PageTitleContainer>
            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 2,
              }}
            >
              {
                subscription.filter((item: any) => item.data.length === 1)
                  .length
              }{" "}
              CHAVES SEM LUTAS (TOTAL)
            </Typography>

            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 2,
              }}
            >
              {
                subscription.filter(
                  (item: any) => filterByGender(item.data).length === 1
                ).length
              }{" "}
              CHAVES SEM LUTAS (FILTRADAS)
            </Typography>

            <Box
              sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("semlutas");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("relatorioTorneio");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Relatório do Torneio
              </Button>
            </Box>
          </PageTitleContainer>

          <SubscriptionContainer>
            {subscription
              .filter((item: any) => filterByGender(item.data).length === 1)
              .map((item: any) => {
                const filteredData = filterByGender(item.data);

                filteredData.sort(
                  (a: { age: number }, b: { age: number }) => a.age - b.age
                );

                if (showData && filteredData.length > 0) {
                  return (
                    <React.Fragment key={item.title}>
                      <PageTitle>{item.title}</PageTitle>
                      {filteredData.map((value: any, index: number) => (
                        <SubscriptionList key={value.id}>
                          <SubscriptionItem
                            style={{
                              backgroundColor:
                                value.genre?.toLowerCase() === "feminino"
                                  ? "#fee0f1"
                                  : "#DBECF4",
                            }}
                          >
                            <SubscriptionContent>
                              <SubscriptionTitle>
                                Inscrição Nº {value.id} {(value.userId === account.id ||
                                    manager) && (
                                      <>
                                        <HistoryIcon
                                          color="action"
                                          sx={{ cursor: 'pointer' }}
                                          onClick={() => showHistorySubsModal(value.id)} />
                                          {' '}
                                        <EditIcon
                                          color="action"
                                          sx={{ cursor: 'pointer' }}
                                          onClick={() => handleEditFighter(value.id)} />

                                      </>
                                    )}
                              </SubscriptionTitle>
                              <SubscriptionDescription>
                                <InfoContainerText>
                                  <span>
                                    <b>Nome:</b>{" "}
                                    {value.fighters
                                      ? value.fighters.name
                                      : value.user.name}
                                  </span>
                                  <span>
                                    <b>Faixa: </b> {value.belt}
                                  </span>

                                  <span>
                                    <b>Idade de luta:</b>{" "}
                                    {value.age + " anos"}
                                  </span>

                                  <span>
                                    <b>Peso:</b> {value.weight.split(";")[0]}
                                  </span>

                                  <span>
                                    <b>Academia: </b>{" "}
                                    {value.fighters
                                      ? value.fighters.gym
                                      : value.user.gym}
                                  </span>



                                </InfoContainerText>
                              </SubscriptionDescription>
                            </SubscriptionContent>
                          </SubscriptionItem>
                        </SubscriptionList>
                      ))}
                    </React.Fragment>
                  );
                } else {
                  return null;
                }
              })}
          </SubscriptionContainer>
        </Content>

        <Content
          id="relatorioTorneio"
          style={{ alignContent: "left", justifyContent: "left" }}
        >
          {/* Campo de entrada para a senha */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "200px",
            }}
          >
            <FormContent onSubmit={handleSubmit(handleCheckPassword)}>
              <FormGroup>
                <Input
                  label="Senha"
                  name="password"
                  type="password"
                  register={register}
                  required
                  error="Este campo é obrigatório"
                  trim={true}
                />
              </FormGroup>
              <FormGroup>
                <Button type="submit">Entrar</Button>
              </FormGroup>
            </FormContent>
          </div>

          {isAuthorized && (
            <div style={{ paddingLeft: 16, paddingRight: 16 }}>
              <h1>Relatório de Inscrições</h1>
              <h2>{quantidadeInscrcaoPagas} Inscrições</h2>
              <h2>{quatidadeDeChaves} Total de Chaves</h2>
              <h2>{quatidadeDeChavesSemLuta} Chaves sem Luta</h2>
              <h2>
                {quatidadeDeChaves - quatidadeDeChavesSemLuta} Chaves com luta
              </h2>

              <h1>Relatório de Medalhas</h1>
              <h2>{medalhasOuro} Ouro</h2>
              <h2>{medalhasPrata} Prata</h2>
              <h2>{medalhasBronze} Bronze</h2>
              <hr />

              <h1> Todas as incrições</h1>

              <TournamentLink
                href={`/subscription/by-owner/${tournament.slug}`}
              >
                Ver Todas As Inscrições
              </TournamentLink>
              <TournamentLink href={`/reportDetail/tournament/${slug}`}>
                Relatório detalhado
              </TournamentLink>

              <ScrollableTable
                columns={columns}
                countCategories={countCategories}
                maxHeight={600}
                borderColor="#3333"
                scrollColor="#000"
              />

              <h1 style={{ marginTop: "50px" }}>Detalhamento das Inscrições</h1>

              <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                <Button
                  variant={filterShirt === "all" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => setFilterShirt("all")}
                >
                  Todos
                </Button>

                <Button
                  variant={filterShirt === "without" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => setFilterShirt("without")}
                >
                  Sem Camisa
                </Button>

                <Button
                  variant={filterShirt === "with" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => setFilterShirt("with")}
                >
                  Com Camisa
                </Button>
              </div>

              {[...subscription.flatMap((c: any) => c.data)]
                .filter((v: any) => {
                  if (filterShirt === "all") return true;
                  if (filterShirt === "with") return v.tShirts != null;
                  if (filterShirt === "without") return v.tShirts == null;
                  return true;
                })
                .sort((a: any, b: any) => {
                  const nomeA = (a.fighters?.name ?? a.user?.name ?? "").toUpperCase();
                  const nomeB = (b.fighters?.name ?? b.user?.name ?? "").toUpperCase();
                  return nomeA.localeCompare(nomeB);
                })
                .map((value: any, index: number) => {
                  const atleta = value.fighters ?? value.user;

                  return (
                    <SubscriptionList key={"detalhe-" + value.id}>
                      <SubscriptionItem
                        style={{
                          backgroundColor:
                            value.genre?.toLowerCase() === "feminino"
                              ? "#fee0f1"
                              : "#DBECF4",
                        }}
                      >
                        <SubscriptionContent>
                          <SubscriptionDescription>
                            <InfoContainerText>
                              <span><b>{tournament.name}</b></span>
                              <span><b>Inscrição Nº {value.id}</b></span>
                              <span>
                                <b>Valor:</b> R$ {value.valueSubscription}
                                <b> status: </b>
                                {value.status ? "Pagamento efetuado" : "Pendente de pagamento"}
                              </span>
                              <span><b>Nome:</b> {atleta.name.toUpperCase()}</span>
                              <span><b>Contato: </b> {atleta.phone}</span>
                              <span>
                                <b>Idade de luta:</b> {value.age} anos
                                <b> Gênero:</b> {value.genre.toUpperCase()}
                              </span>
                              <span><b>Equipe:</b> {atleta.gym.toUpperCase()}</span>
                              <span>
                                <b>Responsável pela inscrição:</b>{" "}
                                {value.user?.name?.toUpperCase()}
                              </span>
                              <span>
                                <b>Contato do responsável: </b>
                                {value.user?.phone}
                              </span>
                              <span>
                                <b>Categoria(s):</b>{" "}
                                {value.genre?.toUpperCase()} ({value.category?.toUpperCase()}) /{" "}
                                {value.belt?.toUpperCase()} / {value.weight?.toUpperCase()} /{" "}
                                {getPesoMaximo(value) || "Não encontrado nas regras"}
                              </span>
                              <span>
                                <b>Camisa:</b>{" "}
                                {!value.tShirts
                                  ? "Sem camisa"
                                  : `${value.tShirts.measure} (${value.tShirts.size}) - ${value.tShirts.color} - ${
                                      value.tShirts.price === 999
                                        ? "CAMISA GRÁTIS"
                                        : `R$${value.tShirts.price}`
                                    }`}
                              </span>
                            </InfoContainerText>
                          </SubscriptionDescription>
                        </SubscriptionContent>
                      </SubscriptionItem>
                    </SubscriptionList>
                  );
                })}

              {/* TABELA CATEGORIAS COM LUTAS E TEMPO */}
              <div style={{ padding: "20px", marginTop: "40px" }}>
                <h1 style={{ fontSize: "1.8rem", fontFamily: "inter, sans-serif" }}>
                  Quantidade de atletas por categoria (Final da Página)
                </h1>

                <ScrollableTable
                  columns={[
                    { label: "Categoria", key: "title" },
                    { label: "Atletas", key: "total" },
                    { label: "Lutas", key: "lutas" },
                    { label: "Tempo (min)", key: "tempoDeLuta" },
                    { label: "Total min", key: "tempoTotal" },
                  ]}
                  countCategories={subscription.map((item: any) => {
                    const total = item.data.length;

                    let lutas = 0;
                    if (total === 2) lutas = 1;
                    if (total === 3) {
                      if (regraChave3 === "chaveDe3Simples") lutas = 2;
                      if (regraChave3 === "chaveDe3MelhorDe3") lutas = 3;
                    }
                    if (total >= 4) lutas = total - 1;

                    const subsExemplo = item.data[0];
                    const tempoDeLuta = getTempoDeLuta(subsExemplo) || 0;
                    const tempoTotal = lutas * tempoDeLuta;

                    return { title: item.title, total, lutas, tempoDeLuta, tempoTotal };
                  })}
                  maxHeight={600}
                  borderColor="#3333"
                  scrollColor="#000"
                />
              </div>

              {/* SIMULADOR */}
              <div style={{ padding: "20px", marginTop: "10px" }}>
                <h1 style={{ fontSize: "1.8rem", fontFamily: "inter, sans-serif" }}>
                  SIMULADOR (Horário / Tatames / Regra de 3)
                </h1>

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    flexWrap: "wrap",
                    marginTop: 2,
                    marginBottom: 3,
                    alignItems: "center",
                  }}
                >
                  <TextField
                    label="Horário de início"
                    type="time"
                    value={eventoInicio}
                    onChange={(e) => setEventoInicio(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 180 }}
                  />

                  <TextField
                    label="Qtd. de tatames"
                    type="number"
                    inputProps={{ min: 1, max: 50 }}
                    value={areasDeLuta}
                    onChange={(e) => setAreasDeLuta(Number(e.target.value))}
                    sx={{ minWidth: 180 }}
                  />

                  <TextField
                    label="Chave com 3 atletas"
                    select
                    value={regraChave3}
                    onChange={(e) =>
                      setRegraChave3(e.target.value as "chaveDe3Simples" | "chaveDe3MelhorDe3")
                    }
                    sx={{ minWidth: 260 }}
                  >
                    <MenuItem value="chaveDe3Simples">Simples (2 lutas)</MenuItem>
                    <MenuItem value="chaveDe3MelhorDe3">Melhor de 3 (3 lutas)</MenuItem>
                  </TextField>

                  <TextField
                    label="Período (min)"
                    type="number"
                    inputProps={{ min: 5, max: 240 }}
                    value={periodoMinutos}
                    onChange={(e) => setPeriodoMinutos(Math.max(5, Number(e.target.value) || DEFAULT_PERIODO_MINUTOS))}
                    sx={{ minWidth: 180 }}
                  />

                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      setEventoInicio(DEFAULT_EVENTO_INICIO);
                      setAreasDeLuta(DEFAULT_AREAS_DE_LUTA);
                      setRegraChave3(DEFAULT_REGRA_CHAVE_3);
                      setPeriodoMinutos(DEFAULT_PERIODO_MINUTOS);
                    }}
                  >
                    Resetar padrão
                  </Button>
                </Box>

                {(() => {
                  const EVENTO_INICIO = eventoInicio;
                  const AREAS_DE_LUTA = areasDeLuta;
                  const PERIODO_MINUTOS = periodoMinutos;
                  const LIMITE_BLOCO = PERIODO_MINUTOS * AREAS_DE_LUTA;

                  const categoriasProcessadas = subscription.map((item: any) => {
                    const total = item.data.length;
                    let lutas = total > 1 ? total - 1 : 0;

                    if (total === 3) {
                      if (regraChave3 === "chaveDe3MelhorDe3") lutas = 3;
                      if (regraChave3 === "chaveDe3Simples") lutas = 2;
                    }

                    const subsExemplo = item.data[0];
                    const tempoDeLuta = getTempoDeLuta(subsExemplo) || 0;
                    const tempoTotal = lutas * tempoDeLuta;

                    return { title: item.title, total, lutas, tempoDeLuta, tempoTotal };
                  });

                  const blocos: any[] = [];
                  let blocoAtual: any[] = [];
                  let somaAtual = 0;

                  categoriasProcessadas.forEach((cat: any) => {
                    if (somaAtual + cat.tempoTotal <= LIMITE_BLOCO) {
                      blocoAtual.push(cat);
                      somaAtual += cat.tempoTotal;
                    } else {
                      blocos.push({ categorias: blocoAtual, minutos: somaAtual });
                      blocoAtual = [cat];
                      somaAtual = cat.tempoTotal;
                    }
                  });

                  if (blocoAtual.length > 0) {
                    blocos.push({ categorias: blocoAtual, minutos: somaAtual });
                  }

                  const somarMinutos = (hora: string, min: number) => {
                    const [h, m] = hora.split(":").map(Number);
                    const total = h * 60 + m + min;
                    const hh = String(Math.floor(total / 60)).padStart(2, "0");
                    const mm = String(total % 60).padStart(2, "0");
                    return `${hh}:${mm}`;
                  };

                  let horarioAtual = EVENTO_INICIO;

                  return (
                    <div style={{ marginTop: "30px" }}>
                      <h1 style={{ fontSize: "1.8rem", fontFamily: "inter, sans-serif" }}>
                        AGRUPAMENTO POR TEMPO E ÁREAS
                      </h1>

                      <TableContainer sx={{ marginTop: 2, border: "1px solid #3333" }}>
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell><b>Bloco</b></TableCell>
                              <TableCell><b>Horário</b></TableCell>
                              <TableCell><b>Minutos (total)</b></TableCell>
                              <TableCell><b>Categorias</b></TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {blocos.map((bloco, index) => {
                              const inicio = horarioAtual;
                              const fim = somarMinutos(inicio, PERIODO_MINUTOS);
                              horarioAtual = fim;

                              return (
                                <TableRow key={index}>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{inicio} — {fim}</TableCell>
                                  <TableCell>{bloco.minutos} min</TableCell>
                                  <TableCell>
                                    {bloco.categorias.map((c: any, i: number) => (
                                      <div key={i}>
                                        {c.title}{" "}
                                        <span style={{ opacity: 0.9, color: "red" }}>
                                          | {c.total} atletas | {c.lutas} lutas | {c.tempoDeLuta} min por luta |{" "}
                                          <b style={{ color: "red" }}>{c.tempoTotal} min no total</b>
                                        </span>
                                      </div>
                                    ))}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  );
                })()}
              </div>
            </div>
          )}
        </Content>

        <HistoryModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          history={historyData}
          title="Inscrição"
          fieldLabels={{
            weight: 'Peso',
            category: 'Categoria',
            age: 'Idade',
            belt: 'Faixa',
          }}
          hiddenFields={
            [
              'tournamentId',
              'valueSubscription',
              'combo_subscription',
              'userId',
              'genre',
              'fightersId',
              'status',
              'tshirtId',
              'championGuarantee',
              'priceChampionGuarantee',
            ]
          }
        />

        <Zoom in={visible}>
          <Fab
            color="primary"
            size="medium"
            onClick={scrollToTop}
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              backgroundColor: "#373737",
              borderRadius: "50%",
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </Zoom>
      </Container>
    </>
  );
};

export default AllCheckCategoriesLijjamCombatIxCombatDeJiuJitsu2026;